

import { useState } from "react";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Ajce Hostel App React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/hostel.jpg";

import { OnUserRequestLogin } from "framework/authentication/authuser";
import { useMaterialUIController } from "context";
function Basic() {
  const [rememberMe, setRememberMe] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setAuthError] = useState("");
  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarProps, setSnackbarProps] = useState({});
  const [uicontrol] = useMaterialUIController();

  const toggleSnackbar = () => {
    setShowSnackbar(!showSnackbar);
  };

  async function onUserClickLogin() {
    setAuthError("");
    try {
      if (email.trim() === "" || password.trim() === "") {
        setSnackbarProps({
          color: "warning",
          icon: "warning",
          title: "Warning",
          content: "Please enter a valid email and password.",
        });
        setShowSnackbar(true);
      } else {
        setIsLoading(true);
        await OnUserRequestLogin(email, password);
        navigate("/");
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error.code);

      let title = "";
      let content = "";

      if (error.code === "auth/user-not-found") {
        title = "User not found";
        content = "Please check your email address and try again.";
      } else if (error.code === "auth/wrong-password") {
        title = "Wrong password";
        content = "Please check your password and try again.";
      }

      setSnackbarProps({
        color: "error",
        icon: "error",
        title: title,
        content: content,
      });

      setShowSnackbar(true);
    }
  }

  function onUserEnterEmail(event) {
    setAuthError("");
    setEmail(event.target.value);
  }

  function onUserEnterPassword(event) {
    setAuthError("");
    setPassword(event.target.value);
  }
  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
          {/* <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <FacebookIcon color="inherit" />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GitHubIcon color="inherit" />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GoogleIcon color="inherit" />
              </MDTypography>
            </Grid>
          </Grid> */}
        </MDBox>
        <MDBox px={3} mb={2}>
          <MDTypography variant="body1" color="error" textAlign="center" textTransform="lowercase">
            {error}
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput type="email" label="Email" fullWidth onChange={onUserEnterEmail} />
            </MDBox>
            <MDBox mb={2}>
              <MDInput type="password" label="Password" fullWidth onChange={onUserEnterPassword} />
            </MDBox>
            {/* <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Remember me
              </MDTypography>
            </MDBox> */}
            <MDBox mt={4} mb={1}>
              <MDButton
                variant="gradient"
                color="info"
                fullWidth
                onClick={onUserClickLogin}
                disabled={isLoading}
              >
                sign in
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                {" "}
                <MDTypography
                  component={Link}
                  to="/authentication/reset-password"
                  variant="button"
                  color={uicontrol.sidenavColor}
                  fontWeight="regular"
                  textGradient
                >
                  Forget password?
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
      <MDSnackbar
        color={snackbarProps.color}
        icon={snackbarProps.icon || ""}
        title={snackbarProps.title || ""}
        content={snackbarProps.content || ""}
        dateTime=""
        open={showSnackbar}
        close={toggleSnackbar}
      />
    </BasicLayout>
  );
}

export default Basic;
